<template>
  <page>
    <page-header :title="pageTitle" :breadcrumbs="breadcrumbs">
      <template slot="actions">
        <slot name="actions"></slot>
      </template>
    </page-header>

    <page-content>
      <slot name="list">
        <rest-list
          :payload="fetchEndpoint"
          ref="list"
          :max-height="listMaxHeight"
          :empty-text="emptyText"
          :no-filters-empty-text="noFiltersEmptyText"
        >
          <slot name="table"></slot>
        </rest-list>
      </slot>
    </page-content>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeader from '@/common/components/page/PageHeaderNew'
import PageContent from '@/common/components/page/PageContent'
import RestList from '@/common/components/rest/RestList'

export default {
  name: 'RestListPageNew',

  components: {
    Page,
    PageHeader,
    PageContent,
    RestList
  },

  props: {
    pageTitle: {
      type: String,
      required: true
    },

    pageSubtitle: {
      type: String,
      required: false
    },

    fetchEndpoint: {
      type: Object,
      required: false
    },

    breadcrumbs: {
      type: Array,
      required: false
    },

    listMaxHeight: {
      type: Number,
      required: false
    },

    emptyText: {
      type: String,
      default: null
    },

    noFiltersEmptyText: {
      type: String,
      default: null
    }
  },

  methods: {
    refresh() {
      this.$refs.list.refresh()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListPageNew.vue